import createContext from 'create-react-context';

var ChartContext = createContext();

var Consumer = ChartContext.Consumer,
    Provider = ChartContext.Provider;
export { Consumer, Provider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/components/ChartContext/index.js
// module id = 299
// module chunks = 0